import Vue from 'vue'

/**
 * 可视化组件
 */
Vue.component('visual-table', require('@/components/Visuals/Table').default)

/**
 * 表单组件
 */
Vue.component('form-image', require('@/components/Forms/Image').default)
